import React from "react"
import SEO from "./seo"
import Monitor from "./monitor"
import { useStaticQuery, graphql } from 'gatsby'
import { useSelector } from 'react-redux'
import MonitorTag from "./monitor-tag"
import DesignSelect from "./design-select"
import ComponentSelect from "./component-select"
import ColorSelect from "./color-select"
import TagInput from "./tag-input"
import PostlaunchBox from "./postlaunchBox"
import { useTranslation } from "react-i18next"
import { defaultStaticContext } from '../context/StaticContext'

const ProductID = ({ currentDesign, updateDesign, product, currentStage, updateStage, updateStock, currentStock, currentLang }) => {
  const data = useStaticQuery(graphql`
    query CaseDataQuery {
      allMdx(filter: {parent: {internal: {mediaType: {eq: "text/mdx"}}}} sort: { fields: [frontmatter___title], order: DESC }) {
        edges {
          node {
            body
            frontmatter {
              title
              product
              featuredImage {
                childImageSharp {
                  fluid(maxWidth: 2400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              case {
                comp
                color
              }
              answer {
                en
                tc
                jp
              }
            }
          }
        }
      }
    }
  `)

  let posts = data.allMdx.edges.filter(post => {
    return post.node.frontmatter.product === product;
  });

  const currentRegion = useSelector(state => state.currentRegion)

  React.useEffect(() => {
    // const shuffledPosts = shuffle(posts)
    // updatePosts(shuffledPosts)
    let myDesignArray = [];
    let filterDesignArry = [];
    let defaultDesign, outofstockArray
    const isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      myDesignArray = localStorage.getItem('myDesign') ? JSON.parse(localStorage.getItem('myDesign')) : [];
      filterDesignArry = myDesignArray.filter(design => {
        return design.product === product;
      });
      outofstockArray = localStorage.getItem('outofstock') ? JSON.parse(localStorage.getItem('outofstock')) : {}
      const itemKey = product + '-' + currentRegion
      if (outofstockArray[itemKey]) {
        updateStock(true)
      } else {
        checkStockStatus()
      }
    }
    if (filterDesignArry.length > 0) {
      // updateDesign(filterDesignArry[filterDesignArry.length - 1])
      updateID('mydesign0')
      defaultDesign =  {
        product: product,
        case: filterDesignArry[filterDesignArry.length - 1].case,
        tag: ""
      }
    } else {
      updateID('inspiration0')
      defaultDesign =  {
        product: product,
        title: defaultStaticContext.design[product][0].name,
        case: defaultStaticContext.design[product][0].case,
        tag: ""
      }
    }
    if (currentDesign.product !== product) {
      updateDesign(defaultDesign)
    }
    if (currentStage !== 'comp-pick') {
      updateDesign(defaultDesign)
    }
  }, []);

  React.useEffect(() => {
    return () => {
      updateStage('design-pick')
    };
  }, []);

  React.useEffect(() => {
    const isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.scrollTo(0, 0)
    }
  }, [currentStage])

  // const [currentStage, updateStage] = React.useState('design-pick')
  const [currentComp, updateComp] = React.useState(0)
  const [currentSide, updateSlide] = React.useState('front')
  const [originalColor, updateOriginalColor] = React.useState([])
  const [currentPosts, updatePosts] = React.useState([])
  const [currentColor, updateColor] = React.useState('')
  const [currentTag, updateTag] = React.useState('')
  const [currentMetaInfo, updateMetaInfo] = React.useState({
          featuredImage: ''
        })
  const [currentID, updateID] = React.useState('')
  const [editIndex, updateEditIndex] = React.useState('')
  const [scrollLeft, updateScrollLeft] = React.useState(0)
  const [bannerDisplay, updateBannerDisplay] = React.useState(false)

  const compSelectClick = (comp) => {
    const currentItem = currentDesign.case[comp];
    updateStage('color-pick')
    updateComp(comp)
    updateColor(currentItem.color)
  }
  const tagSelectClick = () => {
    updateComp('tag')
    updateStage('tag-input')
  }
  const colorSelectClick = (color) => {
    let newCase = currentDesign.case;
    newCase[currentComp].color = color;
    updateDesign({ ...currentDesign, ['case']: newCase });
    // updateTempDesign({ ...tempDesign, ['case']: newCase });
  }
  const resetAll = () => {
    const newCase = currentDesign.case;
    console.log(currentDesign)
    newCase.map((item, index) => {
      if (item.comp === "zipper") {
        item.color = ""
      } else {
        item.color = "white"
      }
    })
    updateTag('')
    updateDesign({ ...currentDesign, ['case']: newCase });
  }
  const backtoCompStage = () => {
    updateStage('comp-pick')
  }
  const backtoDesignStage = () => {
    updateStage('design-pick')
    const composition = currentDesign
    originalColor.map((color, index) => {
      composition.case[index].color = color
    })
    composition.tag = currentTag
    updateDesign(composition)
  }
  const gotoCompStage = () => {
    let oldColorArray = []
    currentDesign.case.map((item, index) => {
      oldColorArray.push(item.color)
    })    
    updateOriginalColor(oldColorArray);
    const newCase = currentDesign.case;
    updateStage('comp-pick')
    updateComp(0)
    updateTag(currentDesign.tag)
    updateDesign({ ...currentDesign, ['case']: newCase});
  }
  const gotoDesignStage = () => {
    if (checkSavable()) {
      updateStage('design-pick')
    }
  }
  const revertColor = () => {
    const index = currentComp;
    let newComposition = currentDesign;
    newComposition.case[index].color = currentColor;
    updateDesign(newComposition)
  }
  const revertTag = () => {
    updateTag(currentDesign.tag)
  }
  const saveTag = () => {
    let newComposition = currentDesign;
    newComposition.tag = currentTag;
    updateDesign(newComposition)
  }
  const checkSavable = () => {
    let savable = true
    currentDesign.case.map((item, index) => {
      if (item.color === "white" && item.comp !== 'zipper') {
        savable = false
      }
    })
    return savable
  }
  const finishDesign = () => {
    if (checkSavable()) {
      const isBrowser = typeof window !== 'undefined';
      const finalDesign = currentDesign;
      currentDesign.product = product;
      let myDesignArray = [];
      if (isBrowser) {
        myDesignArray = localStorage.getItem('myDesign') ? JSON.parse(localStorage.getItem('myDesign')) : [];
        if (editIndex === '') {
          myDesignArray.push(finalDesign)
        } else {
          myDesignArray[editIndex] = finalDesign;
        }
        localStorage.setItem('myDesign', JSON.stringify(myDesignArray));
        updateID('mydesign0')
      }
    }
    
    updateEditIndex('')
  }
  const changeSide = (index) => {
    if (product === 'quick-pocket') {
      if (index === 4) {
        updateSlide('back')
      } else {
        updateSlide('front')
      }
    } else {
      if (index === 4) {
        updateSlide('back')
      } else {
        updateSlide('front')
      }
    }
    if (index === 'front') {
      updateSlide('front')
    } else if (index === 'back') {
      updateSlide('back')
    }
  }

  const shuffle = (array) => {
    var currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array
  }

  const ifOutofStock = (json) => {
    let outofstock = true
    json.map(store => {
      Object.keys(store.quantity).map(function(key, index) {
        if (store.quantity[key] !== 0) {
          outofstock = false
        }
      });
    })
    return outofstock
  }

  const checkStockStatus = () => {
    Promise.all(
      defaultStaticContext.storemap[currentRegion].map(store =>
        fetch('https://asia-east2-create-my-gregory-2021-prod.cloudfunctions.net/app/api/product_stock?store=' + store + '&region=' + currentRegion)
        .then(value => value.json())
      )
    ).then(data => {
      let total = [].concat(...data)
      updateStock(ifOutofStock(total) || (defaultStaticContext.mode === 'post-launch'))
      // if (ifOutofStock(total) || (defaultStaticContext.mode === 'post-launch')) {
      //   updateBannerDisplay(true)
      // }
    });
    // fetch('https://asia-east2-create-my-gregory-2021-prod.cloudfunctions.net/app/api/product_stock?store=' + "tw1" + '&region=' + currentRegion, {
    //   method: 'get',
    //   headers: {
    //     'Content-Type':'application/json; charset=utf-8',
    //     'Access-Control-Allow-Origin': '*'
    //   }
    // }).then(value => value.json())
    // .then(data => {
    //   console.log(data)
    //   updateStock(data.quantity === 0)
    //   if (data.quantity === 0) {
    //     updateBannerDisplay(true)
    //   }
    // })
  }

  const { t } = useTranslation()

  const title = t('product')[product]['name']

  return (
    <div className="productIDPage">
      <SEO title={title} />
      {currentStage === 'design-pick' ? (
        <div className="mobile designSelect__header">
          <h2>{title}</h2>
          <div className="price">{defaultStaticContext.price[currentRegion]['unit']} {defaultStaticContext.price[currentRegion][product]}</div>
        </div>
      ) : currentStage === 'comp-pick' ? (
        <div className="mobile designSelect__header">
          <h2>{title}</h2>
          <button className="resetButton mobile" onClick={() => resetAll()}>reset</button>
        </div>
      ) : currentStage === 'color-pick' ? (
        <h2 className="mobile">{ t('product.component')[currentDesign.case[currentComp].comp] }</h2>
      ) : currentStage === 'tag-input' ? (
        <h2 className="mobile">{ t('product.component.tag') }</h2>
      ) : (
        <></>
      )}
      {currentStage === 'tag-input' ? (
        <MonitorTag
          currentComp={currentComp}
          currentDesign={currentDesign}
          tag={currentTag}
          bannerDisplay={bannerDisplay}
        />
      ) : (
        <Monitor
          currentDesign={currentDesign}
          currentStage={currentStage}
          backtoCompStage={backtoCompStage}
          currentSide={currentSide}
          currentMetaInfo={currentMetaInfo}
          changeSide={changeSide}
          currentProduct={product}
          bannerDisplay={bannerDisplay}
        />
      )}
      <div className="selection" style={{display: bannerDisplay ? 'none' : 'block'}}>
        { currentStage === 'design-pick' ? (
          <DesignSelect
            gotoCompStage={gotoCompStage}
            updateMetaInfo={meta => updateMetaInfo(meta)}
            currentMetaInfo={currentMetaInfo}
            currentProduct={product}
            updateDesign={updateDesign}
            currentDesign={currentDesign}
            title={title}
            currentID={currentID}
            updateID={id => updateID(id)}
            posts={currentPosts}
            resetAll={resetAll}
            updateEditIndex={index => updateEditIndex(index)}
            updateTag={updateTag}
            outofstock={currentStock}
            currentRegion={currentRegion}
            currentLang={currentLang}
            changeSide={changeSide}
          />
        ) : currentStage === 'comp-pick' ? (
          <ComponentSelect
            currentComp={currentComp}
            compSelectClick={compSelectClick}
            currentDesign={currentDesign}
            finishDesign={finishDesign}
            tagSelectClick={tagSelectClick}
            gotoDesignStage={gotoDesignStage}
            changeSide={changeSide}
            currentProduct={product}
            resetAll={resetAll}
            title={title}
            checkSavable={checkSavable()}
            backtoDesignStage={backtoDesignStage}
            currentTag={currentTag}
            scrollLeft={scrollLeft}
            updateScrollLeft={updateScrollLeft} />
        ) : currentStage === 'tag-input' ? (
          <TagInput
            tagValueChange={tag => updateTag(tag)}
            backtoCompStage={backtoCompStage}
            revertTag={revertTag}
            saveTag={saveTag}
            currentTag={currentTag} />
        ) : (
          <ColorSelect
            currentDesign={currentDesign}
            colorSelectClick={colorSelectClick}
            backtoCompStage={backtoCompStage}
            revertColor={revertColor}
            currentComp={currentComp}
            currentProduct={product}
            currentColor={currentColor} />
        )}
      </div>
      <PostlaunchBox
        outofstock={currentStock}
        currentRegion={currentRegion}
        currentProduct={product}
        bannerDisplay={bannerDisplay}
        updateBannerDisplay={updateBannerDisplay} />
    </div>
  )
  // componentWillMount() {
  //   this.inspiration = this.shuffle(props.posts)
  // }
  // componentDidMount() {
  //  
  // }
  // componentWillUnmount() {
  //   props.updateDesign(props.currentDesign, 'design-pick')
  // }
}

export default ProductID